<template>
  <div class="row">
    <div class="col-md-12">
      <div class="filter-component">
        <div class="row col-12 mx-0 px-0">
          <div class="col-md-3 mb-4">
            <Typography
              text="Estado"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label=""
                name="name"
                :options="typesStatus"
                :value="valuesFilter.status"
                :required="false"
                :loading="false"
                :disabled="isLoadingActivitiesArea"
                :placeholder="'Elige un estado'"
                @input="(value) => (valuesFilter.status = value)"
              />
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <Typography
              text="Clasificación"
              variant="CTA"
              color="#5d5fef"
              class="border-filters-title"
            />
            <div class="pt-2 space-y-4">
              <SelectSearch
                label=""
                name="name"
                :options="typeClassifications"
                :value="valuesFilter.classification"
                :required="false"
                :loading="false"
                :disabled="isLoadingActivitiesArea"
                :placeholder="'Elige un clasificación'"
                @input="(value) => (valuesFilter.classification = value)"
              />
            </div>
          </div>
          <div class="col-md-12 mb-5" v-if="isDisabled">
            <div class="d-flex justify-content-end">
              <Button
                small
                pill
                class="mr-2 search"
                :disabled="isLoadingActivitiesArea"
                @click.prevent="submitFilter"
              >
                <span class="mr-2">Aplicar filtros</span>
                <b-spinner v-if="isLoadingActivitiesArea" />
              </Button>
              <Button
                small
                pill
                class="clear"
                @click.prevent="clearFilter"
                :disabled="isLoadingActivitiesArea || !isDisabled"
              >
                Limpiar filtros
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/general/Typography";
import useInputs from "@/components/general/Inputs";
const { SelectSearch, Button } = useInputs();
export default {
  components: {
    Typography,
    Button,
    SelectSearch,
  },
  props: {
    isLoadingActivitiesArea: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valuesFilter: {
        status: null,
        classification: null,
        validity: null,
      },
      typesStatus: [
        {
          id: "without_mitigation",
          name: "Sin mitigación",
        },
        {
          id: "with_mitigation",
          name: "Con mitigación",
        },
      ],
      typeClassifications: [
        {
          id: "highest",
          name: "Riesgo muy alto",
        },
        {
          id: "high",
          name: "Alto riesgo",
        },
        {
          id: "substantial",
          name: "Riesgo sustancial",
        },
        {
          id: "possible",
          name: "Riesgo posible",
        },
        {
          id: "small",
          name: "Riesgo leve",
        },
      ],
    };
  },
  computed: {
    isDisabled() {
      const me = this;
      return Object.values(me.valuesFilter).some(
        (filter) => filter !== null && filter !== ""
      );
    },
  },
  methods: {
    clearFilter() {
      const me = this;
      me.valuesFilter = {
        status: null,
        classification: null,
      };
      me.$emit("submitFilter", null);
    },
    submitFilter() {
      const me = this;
      console.log("me.valuesFilter", me.valuesFilter);
      const searchValue = {
        ...(me.valuesFilter.status && { status: me.valuesFilter.status.id }),
        ...(me.valuesFilter.classification && {
          classification: me.valuesFilter.classification.id,
        }),
      };
      me.$emit("submitFilter", searchValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-component {
  box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175);
  border-radius: 12px;
  padding: 15px;
  .search {
    background-color: #5d5fef;
    border-color: #5d5fef;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
    color: white;
    border: none;
  }
  .clear {
    background-color: #da1414;
    border-color: #da1414;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
    color: white;
    border: none;
  }
}
</style>
